import { JSX } from "react";

import ButtonGroup from "@mui/material/ButtonGroup";
import IconButton from "@mui/material/IconButton";

import CameraIcon from "@mui/icons-material/Camera";
import CameraswitchIcon from "@mui/icons-material/Cameraswitch";
import CloseIcon from "@mui/icons-material/Close";

export type CameraActionbarProps = {
	videoInputs: number;
	disabled?: boolean;

	onCaptureImage: () => void;
	onToggleCamera: () => void;
	onCloseCamera: () => void;
};

function CameraActionbar(props: CameraActionbarProps): JSX.Element {
	return (
		<ButtonGroup>
			<IconButton
				aria-label="capture image"
				disabled={props.videoInputs === 0 || props.disabled}
				onClick={props.onCaptureImage}>
				<CameraIcon />
			</IconButton>
			<IconButton
				aria-label="toggle camera"
				disabled={props.videoInputs <= 1 || props.disabled}
				onClick={props.onToggleCamera}>
				<CameraswitchIcon />
			</IconButton>
			<IconButton aria-label="close camera" onClick={props.onCloseCamera}>
				<CloseIcon />
			</IconButton>
		</ButtonGroup>
	);
}

export default CameraActionbar;
